module.exports = __webpack_public_path__ + "static/media/info-keypoint12button.302ba670.png";